import { Components, Theme } from '@mui/material';

export const components: Components<Omit<Theme, 'components'>> = {
  MuiButton: {
    defaultProps: {
      variant: 'contained',
      color: 'error',
      disableElevation: true,
    },
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        ...(ownerState.variant === 'outlined' && {
          border: `solid 2px ${theme.palette.primary.main} `,
          '&:hover': {
            border: `solid 2px ${theme.palette.primary.main}`,
          },
          '&:focus-visible': {
            border: `solid 2px ${theme.palette.primary.main}`,
          },
          '&.Mui-disabled': {
            border: `solid 2px ${theme.palette.grey['50']}`,
            color: theme.palette.grey['100'],
          },
        }),
        ...(ownerState.variant === 'contained' && {
          '&.Mui-disabled': {
            backgroundColor: theme.palette.grey['50'],
            color: theme.palette.grey['100'],
          },
        }),
        borderRadius: 16,
        fontWeight: '600',
        fontSize: 20,
        minWidth: 100,
        height: 53,
        minHeight: 53,
        textTransform: 'initial',
        '&.MuiLoadingButton-loading': {
          backgroundColor: theme.palette.error.light,
          opacity: 0.6,
        },
      }),
      contained: {
        borderRadius: 16,
      },
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        backgroundColor: '#D9D9D9',
        height: '1rem',
        borderRadius: '1rem',
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiSelect-select': {
          display: 'flex',
          alignItems: 'center',
        },
        '& .MuiFormHelperText-root': {
          lineHeight: '18px',
        },
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: {
        '& .MuiBackdrop-root.MuiModal-backdrop': {
          top: '4.5rem',
          background: 'rgba(117, 87, 87, 0.48)',
          backdropFilter: 'blur(1px)',
        },
        '&.full-screen .MuiBackdrop-root.MuiModal-backdrop': {
          top: 0,
        },
      },
      paper: {
        borderRadius: '1rem',
        padding: '1rem',
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        '&.square': {
          borderRadius: '0.5rem',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, .2)',
          },
        },
        '&.active': {
          backgroundColor: 'rgba(0, 0, 0, .2)',
        },
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        marginTop: 5,
        borderRadius: '1rem',
        padding: 8,
        border: '1px solid #D9D9D9',
      },
      list: {
        padding: 0,
        '& .MuiMenuItem-root.MuiMenuItem-gutters': {
          paddingLeft: 5,
          '&:hover': {
            background: '#FF9B0052',
          },
        },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: '1rem',
      },
    },
  },
  MuiFormControlLabel: {
    styleOverrides: {
      label: {
        fontSize: 20,
      },
    },
  },
};
